import _ from 'lodash';
export function getProfileIds(contentItems) {
    var profileIds = [];
    (contentItems !== null && contentItems !== void 0 ? contentItems : []).forEach(function (contentItem) {
        var _a, _b;
        (_b = (_a = contentItem === null || contentItem === void 0 ? void 0 : contentItem.content) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.forEach(function (imageList) { return imageList === null || imageList === void 0 ? void 0 : imageList.forEach(function (image) { var _a; return profileIds.push.apply(profileIds, ((_a = image === null || image === void 0 ? void 0 : image.profileIds) !== null && _a !== void 0 ? _a : [])); }); });
    });
    return _.uniq(profileIds);
}
//# sourceMappingURL=getProfileIds.js.map